export default __webpack_public_path__ + "static/media/checkedWhite.c6bd951f.svg";